import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import * as COLOR from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_BODY } from '../styles/typography/typography';
var borderRadius = '2px';
var arrowWidth = 10;
export var createTooltipTheme = function createTooltipTheme(type, maxWidth) {
  var isErrorType = type === 'error';
  var color = isErrorType ? COLOR.PROMETHEAN_ERROR_BG : COLOR.PROMETHEAN_DARK_PURPLE;
  var border = isErrorType ? "1px solid ".concat(COLOR.PROMETHEAN_ERROR_OR_DESTRUCT) : 0;
  var getMargin = function getMargin(placement) {
    return isErrorType ? "-".concat(arrowWidth + 1, "px") : "-".concat(arrowWidth, "px");
  };
  var getStyle = function getStyle(placement) {
    var arrowStyle = {
      width: "".concat(arrowWidth, "px"),
      height: "".concat(arrowWidth, "px")
    };
    switch (placement) {
      case 'top':
        return {
          '.MuiTooltip-arrow:before': {
            borderBottomRightRadius: borderRadius,
            borderBottom: border,
            borderRight: border
          },
          '.MuiTooltip-arrow': _objectSpread(_objectSpread({}, arrowStyle), {}, {
            marginBottom: getMargin(placement)
          })
        };
      case 'bottom':
        return {
          '.MuiTooltip-arrow:before': {
            borderTopLeftRadius: borderRadius,
            borderTop: border,
            borderLeft: border
          },
          '.MuiTooltip-arrow': _objectSpread(_objectSpread({}, arrowStyle), {}, {
            marginTop: getMargin(placement),
            marginLeft: -2
          })
        };
      case 'left':
        return {
          marginLeft: 14,
          '.MuiTooltip-arrow:before': {
            borderTopRightRadius: borderRadius,
            borderTop: border,
            borderRight: border
          },
          '.MuiTooltip-arrow': _objectSpread(_objectSpread({}, arrowStyle), {}, {
            marginRight: getMargin(placement),
            marginTop: -2
          })
        };
      case 'right':
        return {
          '.MuiTooltip-arrow:before': {
            borderBottomLeftRadius: borderRadius,
            borderBottom: border,
            borderLeft: border
          },
          '.MuiTooltip-arrow': _objectSpread(_objectSpread({}, arrowStyle), {}, {
            marginLeft: getMargin(placement),
            marginTop: 2
          })
        };
    }
  };
  return createTheme({
    components: {
      MuiTooltip: {
        styleOverrides: {
          popper: {
            '&[data-popper-placement*="top"]': {
              '.MuiTooltip-tooltipPlacementTop': getStyle('top'),
              '.MuiTooltip-tooltipPlacementBottom': getStyle('top')
            },
            '&[data-popper-placement*="bottom"]': {
              '.MuiTooltip-tooltipPlacementTop': getStyle('bottom'),
              '.MuiTooltip-tooltipPlacementBottom': getStyle('bottom')
            },
            '&[data-popper-placement*="left"]': {
              '&[data-popper-placement="left"]': {
                '.MuiTooltip-arrow': {
                  marginTop: '-2px'
                }
              },
              '.MuiTooltip-tooltipPlacementLeft': getStyle('left'),
              '.MuiTooltip-tooltipPlacementRight': getStyle('left')
            },
            '&[data-popper-placement*="right"]': {
              '.MuiTooltip-tooltipPlacementLeft': getStyle('right'),
              '.MuiTooltip-tooltipPlacementRight': getStyle('right')
            }
          },
          tooltip: _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_BODY), {}, {
            backgroundColor: color,
            color: isErrorType ? COLOR.PROMETHEAN_ERROR_OR_DESTRUCT : COLOR.PROMETHEAN_NEUTRAL_WHITE,
            border: border,
            // MUI default 300
            maxWidth: maxWidth,
            '&.EmbersTooltip-small': {
              padding: '6px 8px'
            },
            '&.EmbersTooltip-large': {
              padding: '16px 24px'
            }
          }),
          arrow: {
            color: color,
            overflow: 'unset'
          }
        }
      }
    }
  });
};